var uris = [
  [1, require("/opt/buildhome/repo/js/features/save/img/pensionBeeUS.png?asset")]
];

module.exports = {
  get uri() {
    var ratio = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    for (var i = 0; i < uris.length; i++) {
      if (uris[i][0] >= ratio) return uris[i][1];
    }
    return uris[uris.length - 1][1];
  },
  width: 625,
  height: 500,
  toString: function () {
    return this.uri;
  },
};
